<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="dismiss('close')">
        <ion-icon name="arrow-back-circle-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid fixed>
    <ion-row>
      <ion-col
        size="12"
        style="display: flex; justify-content: center; align-items: center"
      >
        <img
          src="./assets/logoblack-normal.png"
          style="width: auto; max-height: 125px"
        />
      </ion-col>
      <ion-col
        size="12"
        style="display: flex; justify-content: center; align-items: center"
      >
        <ng-container *ngIf="videoUrl; else noInfo">
          <video
            *ngIf="!youtube; else ytVid"
            #video
            class="fullscreen-bg__video"
            id="video"
            controls
            (ended)="dismiss('ended')"
            autoplay="true"
            [src]="videoUrl"
            width="90%"
          ></video>
          <ng-template #ytVid>
            <iframe
              width="100%"
              height="250px"
              [src]="videoUrl | safe"
              allowfullscreen
            >
            </iframe>
          </ng-template>
        </ng-container>

        <ng-template #noInfo>
          <ion-text class="ion-text-center">
            <p>Este vídeo no se encuentra disponible</p>
            <ion-icon name="warning-outline" style="font-size: 20px"></ion-icon>
          </ion-text>
        </ng-template>
      </ion-col>

      <ion-col
        size="12"
        style="display: flex; justify-content: center; align-items: center"
      >
        <ion-button
          expand="block"
          shape="round"
          color="primary"
          (click)="dismiss('close')"
        >
          {{
            from == "welcome"
              ? "Volver a bienvenida"
              : "Volver a entrenamientos"
          }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
